<div class="d-flex gap-2 justify-content-end">
    <ng-container *ngIf="type.toLowerCase().includes('new part')">
        <div class="d-flex">
            <app-button 
             [buttonClass]="'btn btn-sm btn-outline-primary'" 
             (click)="onCreatePart()" 
             [buttonLable]="'Create Part'">
            </app-button>
        </div>
        <div>
            <app-button 
             [buttonClass]="'btn btn-sm btn-outline-success'" 
             (click)="onApproveAlt()" 
             [buttonLable]="'Approve Alt'">
            </app-button>
        </div>
    </ng-container>

    <ng-container *ngIf="type.toLowerCase().includes('new alt') || type.toLowerCase().includes('alternative')">
        <app-button
         [buttonClass]="'btn btn-sm btn-outline-success'"
         (click)="onApproveAlt()"
         [buttonLable]="'Approve Alt'">
        </app-button>
    </ng-container>

    <ng-container *ngIf="type.toLowerCase().includes('currency')">
        <app-button
         [buttonClass]="'btn btn-sm btn-outline-info'"
         (click)="onAddExchangeRate()"
         [buttonLable]="'Add Exchange Rate'">
        </app-button>
    </ng-container>

</div>

